import { useState, useEffect, useMemo } from 'react';
import { getColors } from '../config/colors';
import Storage from '../config/storage';
import { DARK_MODE_EVENT } from '../config/constants';

/**
 * Dark-mode state plus the matching palette, sourced from localStorage.
 *
 * Follows both the `storage` event (another tab) and DARK_MODE_EVENT (this tab,
 * fired by the rail's theme switch — `storage` does not fire in the tab that
 * wrote the value).
 */
export const useDarkModeValue = () => {
  const [isDarkMode, setIsDarkMode] = useState(() =>
    typeof window === 'undefined' ? false : Storage.isDarkModeStored()
  );

  useEffect(() => {
    const sync = () => setIsDarkMode(Storage.isDarkModeStored());

    window.addEventListener('storage', sync);
    window.addEventListener(DARK_MODE_EVENT, sync);

    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(DARK_MODE_EVENT, sync);
    };
  }, []);

  // getColors builds a fresh object; without this every consumer of `colors`
  // saw a new identity on each render and re-ran anything keyed on it.
  const colors = useMemo(() => getColors(isDarkMode), [isDarkMode]);

  return { isDarkMode, colors };
};
